import { loadAsyncComponent } from "./common";
import ProductInquiryFormLink from "./product-inquiry-link";

export default class ProductAvailabilityTable{
    private baseElement: HTMLElement;

    constructor(baseElement: HTMLElement){
        this.baseElement = baseElement;
    }

    async load(): Promise<void>{
        const loadedElement = await loadAsyncComponent(this.baseElement);
        if(!loadedElement){
            return;
        }
        this.baseElement = loadedElement;
        const linkElement = this.baseElement.querySelector('[data-component-part="contact-us-link"]') as HTMLAnchorElement;
        linkElement && new ProductInquiryFormLink(linkElement).init();
    }
}